import { render, staticRenderFns } from "./kuaidi.vue?vue&type=template&id=55e08a58&"
import script from "./kuaidi.vue?vue&type=script&lang=js&"
export * from "./kuaidi.vue?vue&type=script&lang=js&"
import style0 from "./kuaidi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports